 /*
    To Top button
*/
let $toTop = $('#to-top-container');
let trigger = $('#MainContent').offset().top;
$w.on('scroll', function(){
    if ( $w.scrollTop() > trigger ){
        $toTop.addClass('shown');
    }else{
        $toTop.removeClass('shown');
    }
}); 
$('#to-top-container button').on('click', function(e){
    e.preventDefault();
    $('html:not(:animated),body:not(:animated)').animate({
        scrollTop: 0
    }, 600);
});

/*
Header DOM updates
*/
var moveEls = function(){ 
  var $searchBtn = $('#search-open');
  var $clone = $('#utilities-clone');
  var $utilities = $('#utilities'); 
  var $nav = $('#navbar'); 
  if ($w.width() < 1025){
    if (!$clone.find($searchBtn).length ){
      $searchBtn.detach().appendTo($clone);
    }
    if ($('#site-header').find($nav).length) {
      $nav.detach().appendTo('body');
    }
  } else {
    if (!$utilities.find($searchBtn).length) {
      $searchBtn.detach().prependTo($utilities);
    }
    if (!$('#site-header').find($nav).length) {
      $nav.detach().insertAfter($utilities);
    }
  }
}
moveEls();
$w.on('resize', function(){
  moveEls();
});
// in the theme js, but breaks when we move it outside of the normal container
$b.on('click', '.mobile-site-nav__icon', function(e){
  e.preventDefault();
  $(this).siblings('.mobile-site-nav__menu').slideToggle(250);
  $(this).toggleClass('submenu-open');
});

/*
Cart modifications
*/
$('.drawer-overlay').on('click', function(e){
    e.preventDefault();
    window.timber.RightDrawer.close();
});
$('body').on('keyup', function(e){
    // keyCode is getting deprecated use key instead when supported, which makes this messy
    evt = e || window.event;
    var isEscape = false;
    if ("key" in evt) {
        isEscape = (evt.key == "Escape" || evt.key == "Esc");
    } else {
        isEscape = (evt.keyCode == 27);
    }
    if (isEscape) {
        window.timber.RightDrawer.close();
        closeModal();
        $('#search-panel').removeClass('shown');
    }
});

$(window).on('scroll', function(){
  $('#shopify-section-header').toggleClass('is-scrolled',$(window).scrollTop() > 60);
});
$('#search-open').on('click', function(e){
  e.preventDefault();
  $('#search-panel').addClass('shown');
});
$('#search-close').on('click', function(e){
  e.preventDefault();
  $('#search-panel').removeClass('shown');
});
$('#menu-open').on('click', function(e){
  e.preventDefault();
  $('body').addClass('menu-open');
});
$('#menu-close').on('click', function(e){
  e.preventDefault();
  $('body').removeClass('menu-open');
});

/*
Move the search

function setSearchPosition(){
    var $search = $('#open-search-bar').closest('.search-bar');
    var $wideContainer = $('#js-nomadic-search-wide');
    var $narrowContainer = $('#js-nomadic-search-narrow');
    if ($(window).width() > 1170 ){
        if ($wideContainer.find('.search-bar').length < 1 ){
            $search.detach().appendTo($wideContainer);
        }
    }else{
        if ($narrowContainer.find('.search-bar').length < 1) {
            $search.detach().appendTo($narrowContainer);
        }
    }
}
setSearchPosition();
$(window).resize(function(){
    setSearchPosition();
});
*/

/*
Auto external links
*/
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
  }
}

/*
External WP Content
    */
if ($('.embedded-content').length ) {
    $('.embedded-content iframe').iFrameResize({
        // log: true,
        heightCalculationMethod: 'taggedElement',
        checkOrigin: ['https://whosthere.com']
    });
}

/*
Apply line background to policy page titles
*/
$('.shopify-policy__title h1').wrapInner('<span/>');
/*
Some regular page styles depend on this class
*/
$('.shopify-policy__container').addClass('rte');

/*
Expandable gift message in slide out cart
*/
$('body').on('click', '#ajaxcart-note-toggle', function(e){
    e.preventDefault();
    $(this).toggleClass('open');
    $('.ajaxcart__note').slideToggle();
});

/*
PDP Carousel
*/
$("#available-as-carousel").slick({
    dots: false,
    slidesToShow: 1,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 931,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }
    ]
});

/*
Pinterest Tracking
*/
if (window.pintrk) {
    $('body').on('submit', '.product-form, .quick-buy__product-form', function(){
        var $parent = $(this).closest('.product-detail__detail');
        if ($(this).hasClass('quick-buy__product-form')) {
            $parent = $(this).closest('.quickbuy__content-container');
        }
        var price = $parent.find('[data-product-price]').text().replace('$','') * 1;
        var payload = {
            value: price,
            order_quantity: $(this).find('.quantity-proxy').val(),
            currency: 'USD'
        };
        pintrk('track', 'AddToCart', payload);
    });
}

/*
GA Nav Link Tracking
*/
$('body').on('click', '#navbar .nav a', function(e){
  if( typeof ga !== 'undefined' ){
    ga('send', 'event', 'Site Navigation', $(this).text());
  }
});

const storageKeys = {
  items : `emf-${window.collectionId}-items`,
  footer : `emf-${window.collectionId}-footer`
};

/*
AJAX pagination
*/
$('body').on('click', '.collection-load-more', function(e){
  e.preventDefault();
  $(this).find('span').text('Loading...');
  $.ajax({
    url: $(this).attr('href'),
    success: function(data){
      let $newDom = $(data);
      let $newItems = $newDom.find('#product-items').html();
      let $newFooter = $newDom.find('#product-items-footer').html();
      $('#product-items').append($newItems);
      $('#product-items-footer').html($newFooter);
      // store loaded state if we return to the page
      sessionStorage.setItem(storageKeys.items, $('#product-items').html());
      sessionStorage.setItem(storageKeys.footer, $('#product-items-footer').html());
    }
  });
});

// reload state
if (sessionStorage.getItem(storageKeys.items)) {
  $('#product-items').html(sessionStorage.getItem(storageKeys.items));
  $('#product-items-footer').html(sessionStorage.getItem(storageKeys.footer));
}

// clear out saved state when applying a new sort
$('#sort_by').on('change', function(){
  sessionStorage.removeItem(storageKeys.items);
  sessionStorage.removeItem(storageKeys.footer);
});